import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { LoginService } from '../services/login/login.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private router: Router, private loginService: LoginService) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    let sigla = localStorage.getItem('sigla');
    if (localStorage.getItem('flagAlterarSenha') == 'true') {
      this.loginService.removeLoginData();
      this.router.navigate(['login/logout']);
      return false;
    } else if (!sessionStorage.getItem('token')) {
      if (sigla && sigla == 'CAIXA') {
        this.router.navigate(['caixa/login']);
      } else {
        this.router.navigate(['login']);
      }
      return false;
    }
    return true;
  }
}
